<template>
  <div id="app" class="calculator container">
    <div class="calculator__left">
      <router-view/>
    </div>
    <div class="calculator__right">
      <div class="summary">
        <div class="summary__title">
          <span class="summary__title-text">
            {{getSelectedProgramTitle}}
          </span>
        </div>
        <div class="summary__list">
          <div class="summary__item" v-for="item in getSelectedProgramOptions">
            <div class="summary__item-left">
              <img src="img/progCheck.png" alt="" class="summary__item-pic">
            </div>
            <div class="summary__item-right">
              {{item.text}}
              <span class="tooltip" v-if="item.hasTooltip">
                <div class="tooltip__trigger">
                  <img src="img/tooltip.jpg" alt="" class="tooltip__pic">
                </div>
                <div class="tooltip__content" v-text="item.tooltipText"></div>
              </span>
            
            
            </div>
          </div>
          <div class="summary__item" v-if="$route.name !== 'step1'">
            <div class="summary__item-left">
              <img src="img/progCheck.png" alt="" class="summary__item-pic">
            </div>
            <div class="summary__item-right">
              Кол-во застрахованных: {{selectedProgram == 'family' || selectedProgram == 'family-prem' ? 2 : 1}}
            </div>
          </div>
          <div class="summary__item"
               v-if="selectedProgram == 'family' && $route.name !== 'step1' || selectedProgram == 'family-prem' && $route.name !== 'step1'">
            <div class="summary__item-left">
              <img src="img/progCheck.png" alt="" class="summary__item-pic">
            </div>
            <div class="summary__item-right">
              Кол-во застрахованных детей: {{insuredChildren.length}}
            </div>
          </div>
          <div class="summery-links" v-if="$route.name !== 'step1'">
            <div class="summery-links__item">
              
              <div class="summery-links__item-right">
                <a :href="getSelectedProgramType === 1 ? 'example-polis-individ.pdf' : 'example-polis-family.pdf'"
                   class="summery-links__link" target="_blank">
                  Пример полиса
                </a>,&nbsp;<a href="http://zettains.ru/upload/rules/Pravila_NS%2002.04.2019.pdf"
                              class="summery-links__link" target="_blank">
                Правила страхования
              </a>
              </div>
            </div>
          </div>
        </div>
        <div class="summary__footer-wrapper">
          <div class="summary__price">
            <span class="summary__price-elem" v-html="$options.filters.priceFormat(getSelectedProgramPrice)"></span>
          </div>
          <div class="buttons">
            <div class="buttons__left">
              <a v-if="$route.name == 'step2'" href="#" class="button button_width_full" @click.prevent="sendData">
                <span v-if="!isLoading">
                  ОПЛАТИТЬ
                  <svg class="button__pic" width="8" height="12" viewBox="0 0 8 12" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z"/>
                  </svg>
                </span>
                <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
              </a>
              <a v-else href="#" class="button button_width_full" @click.prevent="nextStep">
                <span v-if="!isLoading">
                  КУПИТЬ
                  <svg class="button__pic" width="8" height="12" viewBox="0 0 8 12" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z"/>
                  </svg>
                </span>
                <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
              </a>
            </div>
            <div class="buttons__right">
              <a v-if="$route.name !== 'step1'" href="#" class="button button_type-simple" @click.prevent="prevStep">
                НАЗАД
              </a>
            </div>
          </div>
        </div>
        
        <div v-if="$route.name == 'step2'" class="summary__desc">
          Нажимая кнопку оплатить, Вы соглашаетесь с <a
            href="https://zettains.ru/upload/accounting/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8%20%D0%B8%20%D0%B7%D0%B0%D1%89%D0%B8%D1%82%D1%8B%20%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85%20ZettaIns.pdf?t=1585222488803"
            class="checkbox__link" target="_blank">политикой обработки персональных данных </a>, <a
            href="http://zettains.ru/upload/rules/Pravila_NS%2002.04.2019.pdf" class="checkbox__link" target="_blank">правилами
          страхования</a>, с дополнительными условиями и подтверждаете, что не относитесь к категории ИПДЛ/РПДЛ, являетесь владельцем платежной карты, с которой производится оплата страховой премии, застрахованное лицо не является медицинским работником.
        </div>
      </div>
      <!-- <div class="summery-links">
        <a href="https://zettains.ru/upload/rules/Pravila_NS_FL.pdf" class="summery-links__link" target="_blank">
          Условия страхования
        </a>
        <a href="example_ns-sport.pdf" class="summery-links__link" target="_blank">
          Пример электронного полиса
        </a>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss">

</style>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {mapFields} from 'vuex-map-fields';

  export default {
    components: {},
    created() {
      this.$router.replace('/')
    },
    data() {
      return {
        // count:2
      }
    },
    methods: {
      ...mapActions({
        sendDataRequest:'sendData',
        checkPermission:'checkPermission'
      }),
      async sendData() {
        const valid = await this.$validator.validateAll()
        if (valid && !this.isLoading) {
          const {result} = await this.checkPermission()
          if(!result) {
            this.sendDataRequest()
          } else {
            this.popupIsActive = true
          }
        }
      },
      nextStep() {
        this.$router.push({name: 'step2'})
        this.insuredChildren.length = 1
        window.scrollTo(0, 0);
        // this.$children[0].$refs.buttonNext.click();

        // this.$validator.validateAll().then(valid => {
        //   if (valid) {
        //     this.$router.push({name:`step${this.count}`})
        //   }
        // });

      },
      prevStep() {
        this.$router.push({name: 'step1'})
        window.scrollTo(0, 0);
      }
    },
    computed: {
      ...mapFields({
        isLoading: 'isLoading',
        selectedProgram: 'selectedProgram',
        programms: 'programms',
        insuredChildren: 'insuredChildren',
        agreement: 'agreement',
        schema: 'Schema',
        popupIsActive: 'popupIsActive',
      }),
      ...mapGetters({
        getTotalCost: 'getTotalCost',
        selectedSports: 'getSelectedSports',
        sportTariffs: 'getSportTariffs',
        sum: 'getSum',
        sports: 'getSelectedSports',
        term: 'getTerm',
        peopleCount: 'getCount',
        maxCategory: 'getMaxCategory',
        mail: 'getMail',
        phone: 'getPhone',
        polisDate: 'getPolisDate',
      }),
      getSelectedProgramPrice() {
        return this.programms.find(item => item.value == this.selectedProgram).price
      },
      getSelectedProgramOptions() {
        return this.programms.find(item => item.value == this.selectedProgram).options
      },
      getSelectedProgramTitle() {
        return this.programms.find(item => item.value == this.selectedProgram).text
      },
      getSelectedProgramType() {
        return this.programms.find(item => item.value == this.selectedProgram).type
      },
      // totalCost(){
      //   const {sportTariffs, selectedSports, sum, sports, term, peopleCount} = this
      //   let category = 1;
      //   let cost = '';
      //   if(selectedSports.length){
      //     selectedSports.forEach((el) => {
      //       if(parseInt(el.UF_CATEGORY) > category) {
      //         category = parseInt(el.UF_CATEGORY);
      //       }
      //     })
      //     cost = sportTariffs[sum.value][category][term.value].premium*peopleCount.value;
      //     this.$store.commit('setTotalCost', cost)
      //     return cost;
      //   }
      // },
      buttonDisabled() {
        // if()
      }
    },
    watch: {}
  }
</script>

<style lang="scss">
  .checkbox__link {
    color: #1990FE;
    text-decoration: none;
  }
</style>
